export default defineNuxtPlugin(() => {
  const { getImageFluxUrl } = useImageFlux()

  return {
    provide: { getImageFluxUrl },
  }
})
